export const ERRORS = {
  BOT_NEED_CHALLENGE: 'bot-need-challenge',
}

export const BOT_NEED_CHALLENGE_URL = '/testchallengepage'
